<script>
    import Main from './layout/Main.svelte';
    import { t } from "../i18n";
</script>


<Main title={$t('page.access')}>

    <div class="app-content content">
        <div class="content-overlay"></div>
        <div class="content-wrapper">

            <div class="container-fluid">
                <div class="row">


                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="card-title">{$t('access.agents')}</h4>
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                    <p>{$t('access.none')}</p>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="card-title">{$t('access.add_title')}</h4>
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                    <form method="POST" class="form-horizontal" novalidate>
                                        <div class="row">
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <div class="controls">
                                                        <input type="text" name="text" class="form-control" placeholder={$t('access.fullname')} required>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="controls">
                                                        <input type="text" name="text" class="form-control" placeholder={$t('access.username')} required data-validation-required-message="This field is required">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="controls">
                                                        <input type="password" name="email" class="form-control" placeholder={$t('access.password')} required data-validation-required-message="This field is required">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <button type="submit" class="btn btn-primary">{$t('access.add')}</button>
                                            </div>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>





                </div>
            </div>
        </div>
    </div>

</Main>

